import script from "./ProductsAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsAdmin.vue?vue&type=script&setup=true&lang=js"

import "./ProductsAdmin.vue?vue&type=style&index=0&id=61e6fa56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e6fa56"]])

export default __exports__